import {
  MessageResourceTypeMappings,
  ThreadResourceTypeMappings,
} from '@aa/nest/resource';
import { Message } from '@prisma/client';
import { Socket } from 'socket.io';
import { CoreAppState } from '../core-app.state';
import { createReducer, on } from '@ngrx/store';
import { chatActions } from './chat.actions';

export type ActiveThread = {
  thread: ThreadResourceTypeMappings['resourceWithRelationsT'];
  messages: Message[];
};

export type ChatState = {
  activeThreads: ActiveThread[];
  socket?: Socket;
};

export const initialChatState: ChatState = {
  activeThreads: [],
};

export const chatReducer = createReducer(
  initialChatState,
  on(chatActions.threadConnected, (state, payload) => {
    const activeThreadIndex = state.activeThreads.findIndex(
      (at) => at.thread?.id == payload.thread.id,
    );
    const activeThreads = structuredClone(state.activeThreads);
    // if reconnected to existing active thread, just update data
    if (activeThreadIndex >= 0) {
      console.log('STA');
      activeThreads[activeThreadIndex] = {
        messages: payload.messages,
        thread: payload.thread,
      };
    } else {
      console.log('STB');
      activeThreads.push({
        messages: payload.messages,
        thread: payload.thread,
      });
    }

    return { ...state, activeThreads };
  }),
  on(chatActions.threadsConnected, (state, payload) => {
    const activeThreads = structuredClone(state.activeThreads);

    for (const thread of payload.threads) {
      const index = activeThreads.findIndex((t) => t.thread.id == thread.id);
      if (index >= 0) {
        activeThreads[index] = {
          messages:
            thread.messages as MessageResourceTypeMappings['resourceWithRelationsT'][],
          thread: {
            ...thread,
            messages: undefined,
          },
        };
      } else {
        activeThreads.push({
          messages:
            thread.messages as MessageResourceTypeMappings['resourceWithRelationsT'][],
          thread: {
            ...thread,
            messages: undefined,
          },
        });
      }
    }
    return { ...state, activeThreads };
  }),
  on(chatActions.disconnectFromThread, (state, payload) => ({
    ...state,
    activeThreads: state.activeThreads.filter(
      (at) => at.thread.id != payload.threadId,
    ),
  })),
  on(chatActions.messageAdded, (state, payload) => {
    const activeThreadIndex = state.activeThreads.findIndex(
      (at) => at.thread?.id == payload.threadId,
    );
    const activeThreads = structuredClone(state.activeThreads);
    if (activeThreadIndex >= 0) {
      activeThreads[activeThreadIndex] = {
        ...activeThreads[activeThreadIndex],
        messages: [
          ...activeThreads[activeThreadIndex].messages,
          payload.message,
        ],
      };
    }

    return { ...state, activeThreads };
  }),
  on(chatActions.messageUpdated, (state, payload) => {
    const activeThreadIndex = state.activeThreads.findIndex(
      (at) => at.thread?.id == payload.threadId,
    );
    const activeThreads = structuredClone(state.activeThreads);
    if (activeThreadIndex >= 0) {
      activeThreads[activeThreadIndex] = {
        ...activeThreads[activeThreadIndex],
        messages: activeThreads[activeThreadIndex].messages.map((m) =>
          m.id == payload.message.id ? payload.message : m,
        ),
      };
    }

    return { ...state, activeThreads };
  }),
);

export const selectChat = (state: CoreAppState) => state.chat;
